import { cn } from '@/lib/utils'

// Cabeçalho padrão das seções: rótulo, título e subtítulo opcional.
function SectionHeading({ eyebrow, title, description, as: Title = 'h2', align = 'center', className }) {
  return (
    <div
      className={cn(
        'flex max-w-2xl flex-col gap-3',
        align === 'center' && 'mx-auto items-center text-center',
        className
      )}
    >
      {eyebrow && (
        <span data-reveal className="eyebrow">
          {eyebrow}
        </span>
      )}
      <Title data-split className="text-3xl font-bold text-foreground md:text-5xl">
        {title}
      </Title>
      {description && (
        <p data-reveal className="text-base leading-relaxed text-pretty text-muted-foreground">{description}</p>
      )}
    </div>
  )
}

export default SectionHeading
